import { applyMixins, DRef, Disposable } from '@zephyr3d/base';
import { mixinDrawable } from '../render/drawable_mixin.js';
import { QUEUE_OPAQUE } from '../values.js';

class MeshDrawableBase extends Disposable {
    _node;
    constructor(node){
        super();
        this._node = node;
    }
    getName() {
        return this._node.name;
    }
    getNode() {
        return this._node;
    }
}
class MeshDrawable extends applyMixins(MeshDrawableBase, mixinDrawable) {
    _material;
    _primitive;
    constructor(node, material, primitive){
        super(node);
        this._material = new DRef(material);
        this._primitive = new DRef(primitive);
    }
    get material() {
        return this._material.get();
    }
    set material(mat) {
        this._material.set(mat);
    }
    getMaterial() {
        return this.material;
    }
    get primitive() {
        return this._primitive.get();
    }
    set primitive(prim) {
        this._primitive.set(prim);
    }
    getPrimitive() {
        return this.primitive;
    }
    getPickTarget() {
        return {
            node: this.getNode()
        };
    }
    getBoneMatrices() {
        return null;
    }
    getMorphData() {
        return null;
    }
    getMorphInfo() {
        return null;
    }
    /**
   * {@inheritDoc Drawable.getSortDistance}
   */ getSortDistance(camera) {
        const cameraWorldMatrix = camera.worldMatrix;
        const objectWorldMatrix = this.getNode().worldMatrix;
        const dx = cameraWorldMatrix.m03 - objectWorldMatrix.m03;
        const dy = cameraWorldMatrix.m13 - objectWorldMatrix.m13;
        const dz = cameraWorldMatrix.m23 - objectWorldMatrix.m23;
        return dx * dx + dy * dy * dz * dz;
    }
    getQueueType() {
        return this._material.get()?.getQueueType() ?? QUEUE_OPAQUE;
    }
    needSceneColor() {
        return this._material.get()?.needSceneColor() ?? false;
    }
    needSceneDepth() {
        return this._material.get()?.needSceneDepth() ?? false;
    }
    isUnlit() {
        return !this._material.get()?.supportLighting();
    }
    isBatchable() {
        return !!this._material.get() && this._material.get().isBatchable();
    }
    draw(ctx, renderQueue) {
        const material = this.material;
        const primitive = this.primitive;
        if (material && primitive) {
            this.bind(ctx, renderQueue);
            material.draw(primitive, ctx);
        }
    }
    onDispose() {
        super.onDispose();
        this._material.dispose();
        this._primitive.dispose();
    }
    getName() {
        return this.getNode().name;
    }
}

export { MeshDrawable, MeshDrawableBase };
//# sourceMappingURL=meshdrawable.js.map
